import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '@usucampeao/utils-frontend';
import { FooterModule, HeaderModule } from '../../../components';
import { ProjetosCalendarioComponent } from './projetos-calendario/projetos-calendario.component';
import { ProjetosDetalhesPage } from './projetos-detalhes.page';

@NgModule({
  declarations: [
    ProjetosDetalhesPage,
    ProjetosCalendarioComponent,
  ],
  imports: [
    // root
    CommonModule,
    IonicModule,

    // components
    HeaderModule,
    IonicModule,
    FooterModule,

    // others
    PipesModule,
  ],
  exports: [
    ProjetosDetalhesPage,
    ProjetosCalendarioComponent,
  ],
  providers: [DatePipe]
})
export class ProjetosDetalhesPageModule { }
